const formatFlightFareKey = (fare) =>
  fare
    ? `${fare.fareBasisCode}-${fare.isRefundable}-${fare.price}-${fare.pricingSubsource}-${fare.fareBrandId}-${(fare.offer || {}).offerId}`
    : '';

export default formatFlightFareKey;
